import { Button, Col, Container, Row } from "react-bootstrap";
import Deta from "../../Deta";

function Orders(){
    const orders = Deta.map((items) => {
        return(
                    <Col lg={4} key={items.id} style={{fontWeight:'bold'}}>
                        <img style={{width:'100%', borderRadius:'10px'}} src={items.imge} alt=""></img> 
                        <h4 style={{color:'#43121d', fontWeight:'700',fontSize:'18px'}}>{items.title}</h4>
                        <p style={{color:'#555',fontSize:'18px'}}>{items.time}</p>
                        <p style={{ color:'#a82d49',fontSize:"24px"}}>{items.price}</p>
                        <Button style={{backgroundColor:'#a82d49',border:'3px solid #a82d49',color:'white',borderRadius:'0'}}>Order Now</Button>
                    </Col>
        )
    })
    return(
        <Container>
            <Row>
                {orders}
            </Row>
        </Container>
    )
}

export default Orders;